import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { MessagesScreenAction } from 'redux/reducers/messagesReducer';

export const setVenues = (
  venues: readonly string[]
): Action<MessagesScreenAction, readonly string[]> =>
  createAction(MessagesScreenAction.setVenues, venues);
